import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function SlotRequestsAdmin() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const load = async () => { try { const { data } = await api.get("/admin/slot-requests?status=pending"); setItems(data); } catch { /* admin can retry */ } };
  useEffect(() => { load(); }, []);
  const decide = async (req, decision) => {
    let approved_additional_slots = null;
    if (decision === "approved") {
      const input = window.prompt("How many extra slots should be approved?", String(req.additional_slots));
      if (input === null) return;
      approved_additional_slots = Number(input);
      if (!Number.isInteger(approved_additional_slots) || approved_additional_slots < 1 || approved_additional_slots > 1000) {
        toast.error("Enter a number from 1 to 1000"); return;
      }
    }
    const note = window.prompt("Optional reason or approval note", "");
    if (note === null) return;
    setBusy(req.id);
    try {
      await api.post(`/admin/slot-requests/${req.id}/decision`, { decision, approved_additional_slots, note });
      toast.success(`Request ${decision}`); await load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  return <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid="admin-slot-requests">
    <div className="mb-4 flex items-center justify-between"><h2 className="font-semibold text-slate-900">Extra free monitor requests ({items.length})</h2><button onClick={load} className="text-sm font-medium text-blue-600">Refresh</button></div>
    {!items.length ? <p className="text-sm text-slate-500">No pending requests.</p> :
    <div className="space-y-3">{items.map(r => <div key={r.id} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border p-3">
      <div className="min-w-0"><p className="font-medium text-slate-900">{r.email} · +{r.additional_slots} requested</p><p className="max-w-xl break-words text-sm text-slate-500">{r.reason}</p></div>
      <div className="flex gap-2"><button disabled={!!busy} onClick={() => decide(r, "approved")} className="rounded-lg bg-emerald-600 px-3 py-2 text-sm text-white disabled:opacity-50">Approve</button><button disabled={!!busy} onClick={() => decide(r, "rejected")} className="rounded-lg border px-3 py-2 text-sm disabled:opacity-50">Reject</button></div>
    </div>)}</div>}
  </section>;
}
